const RECOVER_PASSWORD_PAGE = {
  title: 'Esqueceu sua senha?',
  subtitle: 'Digite seu e-mail para redefinir a senha.',
  emailLabel: 'E-mail',
  recoverButton: 'Confirmar',
  titleSuccess: 'Feito!',
  subtitleSuccess: 'Enviamos um e-mail com um link para redefinir sua senha.',
  successButtonLabel: 'Volta',
  invalidEmailLabel: 'Este endereço de e-mail não é válido ...',
  verificationCodeInputLabel: 'Insira o código de ativação recebido no seu',
  verificationCodeInputLabelHexa: 'Inserir o código de ativação',
  email: 'e-mail',
  phone: 'telefone',
  newPasswordInputLabel: 'Nova Senha',
  newPasswordConfirmationInputLabel: 'Confirmar a senha',
  passwordsDontMatchErrorMessage: 'As senhas não coincidem',
  changedPasswordSuccessMessage:
    'Senha redefinida com sucesso. Por favor logue novamente usando sua nova senha!',
  error: 'ERRO',
  ok: 'OK',
  defaultRequestError: 'Houve um erro, tente novamente mais tarde',
  tooManyAttemptsError:
    'Você excedeu o número de tentativas para redefinição de senha. Por favor, tente novamente mais tarde.',
  cancel: 'Cancelar',
  goBack: 'Voltar',
  UserNotFoundException: 'Usuário não encontrado',
  resetPassword: 'Redefinir',
  resetPasswordHexa: 'Redefinir senha',
  activationCode: 'Código de ativação para redefinir senha',
  activationCodeSendTo: 'O código de ativação foi enviado para',
  checkActivationCode:
    ' e expira em 1 hora. Caso não tenha recebido, verifique se o e-mail foi digitado corretamente ou se caiu na caixa de spam.',
  hexaActivationPrefix: 'Código enviado para',
  hexaActivationSuffix:
    '. Ele expira em 1h. Se não encontrar, confira se o endereço está certo ou veja na caixa de spam.',
  passwordShouldContain: 'Sua nova senha deve conter:',
  passwordTip:
    'Mínimo de 10 caracteres com letras, números e caracteres especiais',
  codeSendToSMS: 'O código de ativação foi enviado por SMS para',
  expiresInOneHour:
    ' e expira em 1 hora. Caso tenha algum problema, envie um email para',
  partner: ' parceiro_ze@ambev.com.br',
  destinationTypeError: 'Verifique o destination type.',
}

export default RECOVER_PASSWORD_PAGE
